import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** B2BCLOUD-2770: Фича АПИ миграции с v2 -> v4 для ручки domain/* */
export const apiMigrateDomainFoldersV2ToV4: boolean = isFeature('api-migrate-v2-to-v4-domain');
